import { fetchApiWithAllFilters } from "@modules/azm/api"
import { getCategories, setCategories } from "@modules/azm/category"
import { getFilters, setFilters } from "@modules/azm/filter"
import { resetPagination } from "@modules/azm/pagination/pagination"
import { filterConfig } from "@modules/global/filter-config.ts"
import { isMobile } from "@modules/util/device"
import { afterFilterApiFetched } from "../after-filter-api-fetched"
import { FILTER_GROUP_NAME_MAP } from "../filter-group-name-map"
import { updateFilterCategoryCheckboxes } from "./category-checkboxes"
import { updateActiveFilterBarInDom } from "./filter-bar"
import { updateFilterCheckboxes } from "./filter-checkboxes"
import { setSearchText } from "./search-text-data"
import { updateSearchTextInDom } from "./searchtext"

export function createActiveFilterGroup(groupName: string, displayGroup: string, values: string[]) {
    const groupContainer = createActiveFilterGroupContainer()
    groupContainer.appendChild(createActiveFilterGroupElement(groupName, displayGroup))
    if (filterConfig.groups.select.includes(groupName)) {
        let valueSuffix = ""
        if (groupName === "groesse") {
            valueSuffix = " cm"
        }
        if (values[0])
            groupContainer.appendChild(
                createActiveFilterValueElement(groupName, "von", `von ${values[0]}${valueSuffix}`),
            )
        if (values[1])
            groupContainer.appendChild(
                createActiveFilterValueElement(groupName, "bis", `bis ${values[1]}${valueSuffix}`),
            )
    } else if (groupName === "suchtext") {
        groupContainer.appendChild(createActiveFilterValueElement(groupName, addPlusOutsideQuotes(values[0])))
    } else {
        for (const value of values) {
            groupContainer.appendChild(createActiveFilterValueElement(groupName, value))
        }
    }
    return groupContainer
}

function addPlusOutsideQuotes(input: string) {
    const parts = input.match(/"[^"]*"|\S+/g) || []

    return parts
        .map((part: string) => {
            if (part.startsWith('"') && part.endsWith('"')) {
                return part
            }
            return part
        })
        .join(" + ")
        .replace(/\+ "\S/, (match: string) => match.replace("+ ", " "))
}

function createActiveFilterGroupContainer() {
    const groupContainerElement = document.createElement("div")
    groupContainerElement.classList.add("btn-group")
    return groupContainerElement
}

function createActiveFilterGroupElement(groupName: string, displayGroup: string) {
    const parameterGroupElement = document.createElement("button")
    parameterGroupElement.setAttribute("data-group", groupName)
    parameterGroupElement.classList.add(
        "btn",
        "btn-traits",
        "btn-default",
        "merkmal-group-button",
        "chosen-trait-group-button",
    )
    parameterGroupElement.innerText = displayGroup
    return parameterGroupElement
}

function createActiveFilterValueElement(groupName: string, value: string, text = "") {
    const parameterValueElement = document.createElement("button")
    parameterValueElement.setAttribute("data-value", value)
    parameterValueElement.setAttribute("data-group", groupName)
    parameterValueElement.classList.add("btn", "btn-traits", "btn-default", "merkmal-button", "chosen-trait-button")
    parameterValueElement.innerText = text || FILTER_GROUP_NAME_MAP[groupName]?.values[value].text || value
    return parameterValueElement
}

export function createActiveFilterDeleteAllButton() {
    const group = createActiveFilterGroupContainer()
    const deleteAllFilterButton = document.createElement("button")
    if (isMobile()) {
        const deleteAllFilterSpan = document.createElement("span")
        deleteAllFilterSpan.classList.add("icon", "inline", "icon-16", "primary", "remove-filter-icon")
        deleteAllFilterSpan.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" data-icon-id="trash-outline" viewBox="0 0 16.16 21.2"><path d="M2.29 21.2a.6.6 0 0 1-.6-.53L0 6a.6.6 0 0 1 .15-.46.6.6 0 0 1 .45-.2h14.97a.72.72 0 0 1 .47.24.6.6 0 0 1 .12.43L14.5 20.67a.59.59 0 0 1-.59.53Zm.53-1.2h10.56L14.9 6.54H1.3Zm2-2.4a.6.6 0 0 1-.6-.56l-.59-7.92a.62.62 0 0 1 .15-.45.6.6 0 0 1 .41-.2.63.63 0 0 1 .64.53l.55 8a.6.6 0 0 1-.15.44.58.58 0 0 1-.39.21Zm3.32 0a.6.6 0 0 1-.6-.6V9.07a.6.6 0 1 1 1.2 0V17a.6.6 0 0 1-.64.6Zm3.27 0a.6.6 0 0 1-.56-.64L11.37 9a.61.61 0 0 1 .63-.53.6.6 0 0 1 .44.21.58.58 0 0 1 .15.43L12 17a.59.59 0 0 1-.6.56ZM.56 3.87a.6.6 0 0 1 0-1.2H4.5L5.56.35A.62.62 0 0 1 6.11 0h4a.59.59 0 0 1 .54.35l1.07 2.32h3.88a.59.59 0 0 1 .57.57.57.57 0 0 1-.15.43.62.62 0 0 1-.42.2zm5.26-1.2h4.55l-.68-1.48H6.5Z"></path></svg>&nbsp;Alle Filter löschen'
        deleteAllFilterButton.appendChild(deleteAllFilterSpan)
    } else {
        deleteAllFilterButton.innerText = "ALLE FILTER LÖSCHEN"
    }
    deleteAllFilterButton.classList.add("btn", "btn-traits", "btn-default", "remove-filter-button")
    deleteAllFilterButton.addEventListener("click", async () => {
        setFilters({})
        setCategories([])
        resetPagination()
        setSearchText("")
        updateSearchTextInDom()
        updateFilterCheckboxes(getFilters())
        updateFilterCategoryCheckboxes(getCategories())
        updateActiveFilterBarInDom()
        afterFilterApiFetched(await fetchApiWithAllFilters())
    })
    group.appendChild(deleteAllFilterButton)
    return group
}
